import { getMiddlewareRoot } from "@/utils/helpers/configs"
import { productIds } from "@/utils/helpers/mappings"
import { ProductNumber } from "@/types/General"

const ALLOWED_PRODUCT_IDS = new Set(
  Object.keys(productIds).map((key) => Number(key))
)

const EFFECTIVE_DATE_RE = /^\d{4}-\d{2}-\d{2}$/

export function isAllowedProductNumber(id: ProductNumber): boolean {
  return ALLOWED_PRODUCT_IDS.has(Number(id))
}

export function isAllowedEffectiveDate(date: string): boolean {
  return EFFECTIVE_DATE_RE.test(date)
}

/** Member Link API account-balances URL; rejects non-allowlisted product ids and dates. */
export function productAccountBalancesUrl(
  id: ProductNumber,
  effectiveDate: string
): string {
  if (!isAllowedProductNumber(id)) {
    throw new Error("Refusing request: product id is not allowlisted")
  }
  if (!isAllowedEffectiveDate(effectiveDate)) {
    throw new Error("Refusing request: effectiveDate must be YYYY-MM-DD")
  }

  const apiRoot = getMiddlewareRoot()
  return `${apiRoot}/product/${encodeURIComponent(String(id))}/account-balances?effectiveDate=${encodeURIComponent(effectiveDate)}`
}
